/**
 * Run `fn` up to `attempts` times. Between attempts, wait `delayMs(attempt)`
 * and call `onRetry(err, attempt)` so the caller can refresh state (e.g. mint
 * a fresh presigned URL). Rethrows the last error once attempts are spent.
 */
export async function withRetries(
  fn,
  { attempts = 3, delayMs = (attempt) => 500 * attempt, shouldRetry = () => true, onRetry } = {},
) {
  let lastErr;
  for (let attempt = 1; attempt <= attempts; attempt += 1) {
    try {
      return await fn(attempt);
    } catch (err) {
      lastErr = err;
      if (attempt >= attempts || !shouldRetry(err, attempt)) throw err;
      const wait = delayMs(attempt);
      if (wait > 0) await new Promise((r) => setTimeout(r, wait));
      if (onRetry) await onRetry(err, attempt);
    }
  }
  throw lastErr;
}
